import moment from 'moment'

export default {
  data() {
    return {
      searchSchema: [
        {
          label: '报告时间',
          type: 'rangePicker',
          dateFormat: 'YYYY-MM-DD',
          itemName: 'date',
          allowClear: true,
        },
      ],
      searchForm: {
        date: [moment(new Date()).subtract(3, 'months'), moment()],
        productLine: '',
        startTime: '',
        endTime: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '时期',
          width: 120,
          dataIndex: 'time',
        },
        {
          title: '产品线',
          width: 140,
          dataIndex: 'productLine',
        },
        {
          title: '库存金额(元)(含在途货物及非联想进货)',
          width: 280,
          dataIndex: 'stockAmount',
        },
        {
          title: '应收金额(元)',
          width: 180,
          dataIndex: 'receivableAmount',
        },
        {
          title: '销售收入(元)(含非联想进货)',
          width: 220,
          dataIndex: 'incomeAmount',
        },
        {
          title: '应付金额(元)(含非联想进货)',
          width: 220,
          dataIndex: 'dueAmount',
        },
        {
          title: '在途金额(元)',
          width: 150,
          dataIndex: 'onRoadAmount',
        },
        {
          title: '进货额(元)',
          width: 150,
          dataIndex: 'pickAmount',
        },
        {
          title: '提货(非联想进货）(元)',
          width: 180,
          dataIndex: 'pickupAmountNonLenovo',
        },
        {
          title: '外部融资额(元)',
          width: 150,
          dataIndex: 'outFinancingAmount',
        },
        {
          title: '信用融资额(元)',
          width: 150,
          dataIndex: 'creditFinancingAmount',
        },
        {
          title: '联想金融融资额(元)',
          width: 200,
          dataIndex: 'lenovoFinancingAmount',
        },
        {
          title: '库存周转(天)',
          width: 160,
          dataIndex: 'stockTurn',
        },
        {
          title: '应收周转(天)',
          width: 150,
          dataIndex: 'receivableTurn',
        },
        {
          title: '应付周转(天)',
          width: 150,
          dataIndex: 'dueTurn',
        },
        {
          title: '自投资金(元)',
          width: 150,
          dataIndex: 'selfInvestAmount',
        },
        {
          title: '自投比例(%)',
          width: 150,
          dataIndex: 'selfInvestRate',
        },
        {
          title: '净自投资金(元)',
          width: 150,
          dataIndex: 'netSelfInvestAmount',
        },
        {
          title: '净自投比例(%)',
          width: 150,
          dataIndex: 'netSelfInvestRate',
        },
        {
          title: 'OTC销售(元)',
          width: 150,
          dataIndex: 'otcSell',
        },
        {
          title: 'OTC收款(元)',
          width: 150,
          dataIndex: 'otcReceivableAmount',
        },
        {
          title: '折扣金额(元)',
          width: 150,
          dataIndex: 'discountAmount',
        },
        {
          title: '销售金额(元)',
          width: 150,
          dataIndex: 'sellAmount',
        },
        {
          title: '逾期金额(元)',
          width: 150,
          dataIndex: 'overdueAmount',
        },
        {
          title: 'OTC(天)',
          width: 150,
          dataIndex: 'otcDay',
        },
        {
          title: '现金点(%)',
          width: 150,
          dataIndex: 'cashPoint',
        },
        {
          title: '逾期率(%)',
          width: 150,
          dataIndex: 'overdueRate',
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
